/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useChannelIOApi } from "react-channel-plugin";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
// import ChannelBotIcon from "../assets/img/channel_bot_icon.png";
import { stateMyInfo } from "../store/myinfo/myinfoSlice";

// interface FollowUpProfile {
//   name?: string | null;
//   mobileNumber?: string | null;
//   email?: string | null;
// }

function ChannelBot() {
  const {
    boot,
    showMessenger,
    shutdown,
    hideChannelButton,
    showChannelButton,
    updateUser,
  } = useChannelIOApi();
  // const [isMobile, setIsMobile] = useState<boolean>(false);
  // const forMobile = () => {
  //   const user = navigator.userAgent;
  //   // noneExpireSetCookie("splash", "none-expire");
  //   // const asdf = noneExpireGetCookie("splash");
  //   // console.log("none-cookie", asdf);
  //   if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
  //     setIsMobile(true);
  //   }
  // };
  // useEffect(() => {
  //   forMobile();
  // }, []);
  // const { showMessenger, updateUser } = useChannelIOApi();

  const { isMyInfo } = useSelector(stateMyInfo);
  const [userName, setUserName] = useState<any>();
  const [userCel, setUserCel] = useState<any>();
  const [userEmail, setUserEmail] = useState<any>();
  const [userMileage, setUserMileage] = useState<any>();
  const [userCoupon, setUserCoupon] = useState<any>();
  const [userCouponCnt, setUserCouponCnt] = useState<any>();
  const [userPaymentCnt, setUserPaymentCnt] = useState<any>();
  const [userPaymentAmount, setUserPaymentAmount] = useState<any>();
  const [userPaymentLatest, setUserPaymentLatest] = useState<any>();
  const [userRequest, setUserRequest] = useState<any>();
  const [userRequestCnt, setUserRequestCnt] = useState<any>();
  const [userRequestTime, setUserRequestTime] = useState<any>();

  // console.log("channel", isMyInfo);

  const location = useLocation();
  useEffect(() => {
    setUserName(isMyInfo.data?.user_name); // str
    setUserCel(isMyInfo.data?.user_cel); // str
    setUserEmail(isMyInfo.data?.user_email); // str
    setUserMileage(isMyInfo.data?.mileage); // num
    setUserCoupon(isMyInfo.data?.coupon_yn); // str
    setUserCouponCnt(isMyInfo.data?.coupon_cnt); // num
    setUserPaymentCnt(isMyInfo.data?.payment_cnt); // num?
    setUserPaymentAmount(isMyInfo.data?.payment_amount); // num?
    setUserPaymentLatest(isMyInfo.data?.payment_latest); // str?
    setUserRequest(isMyInfo.data?.request_yn); // str?
    setUserRequestCnt(isMyInfo.data?.request_cnt); // num?
    setUserRequestTime(isMyInfo.data?.request_time); // str?
  }, [isMyInfo]);

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === "/review" ||
      location.pathname === "/request/details" ||
      location.pathname === "/brandstory" ||
      location.pathname === "/magazine"
    ) {
      boot();
      if (isMyInfo) {
        updateUser({
          profile: {
            name: userName,
            email: userEmail,
            mobileNumber: `+82${userCel}`,
            mileage: userMileage,
            coupon: userCoupon,
            couponCnt: userCouponCnt,
            payment: userPaymentCnt,
            paymentAmount: userPaymentAmount,
            paymentLatest: userPaymentLatest,
            request: userRequest,
            requestCnt: userRequestCnt,
            requestTime: userRequestTime,
          },
        });
      }

      showChannelButton();
    } else {
      hideChannelButton();
      shutdown();
    }
  }, []);

  return (
    <div onClick={showMessenger}>
      {/* <img
          src={ChannelBotIcon}
          alt="채널봇 이미지"
          style={{ width: "100%" }}
        /> */}
    </div>
  );
}

export default ChannelBot;
